import { AfterViewInit, Component, OnInit } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { FormBuilder, FormGroup, FormControl, Validators, AsyncValidatorFn } from '@angular/forms';
import { NzModalRef, NzNotificationService } from 'ng-zorro-antd';
import { URLS } from '../../../shared/constant/interface';
import { debounceTime } from 'rxjs/operators';
import { of } from 'rxjs';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { DialogService, MessageService } from 'mmmo-mo-common-lib';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.less'],
})
export class VoiceChannelEditComponent implements OnInit, AfterViewInit {
  static NAME = 'icc-msg-channel-edit';
  constructor(
    // private modal: NzModalRef,
    public http: _HttpClient,
    private fb: FormBuilder,
    private dialogService: DialogService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private messageService: MessageService
  ) { }
  record: any = {};

  optionList: any[] = [];
  provider = null;
  form: FormGroup = this.fb.group({
    id: new FormControl(null),
    providerId: new FormControl(null, [Validators.required]),
    name: new FormControl(null, [Validators.maxLength(50), Validators.required]),
    identity: new FormControl(null, [
      Validators.maxLength(50),
      Validators.required,
      Validators.pattern('^[a-zA-Z][a-zA-Z0-9_-]*$'),
    ]),
    msgType: new FormControl(null),
    appId: new FormControl(null, [Validators.required]),
    appKey: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
    appSecret: new FormControl(null, [Validators.required]),
    channelNum: new FormControl(null, [Validators.maxLength(50), Validators.required, Validators.pattern('^[0-9]*$')]),
    carrierId: new FormControl(null, [Validators.required]), // 所属地区运营商
    speed: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]*$'), Validators.max(5000)]),
    hidControl: new FormControl(null, [Validators.required]),
    hidNameControl: new FormControl(null, [Validators.required]),
    state: new FormControl(null), // 通道状态
    templateId: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]*$')]), // 语音模板ID
  });
  checkDisable = false;
  subject = '语音渠道';
  isSubmit = false;
  nameHid = true;
  identityHid = true;
  ngOnInit(): void {
    const urlSel = URLS.searchChannelProvider.url;
    this.activeRoute.params.subscribe((params: ParamMap) => {
      if(params['id']) {
        this.record.id = params['id'];
      }
    })
    this.form.get('state').setValue(1);
    if (this.record.id > 0) {
      this.http.post(urlSel, 3).subscribe(res => {
        this.optionList = res.data;
      });
      const str = sessionStorage.getItem(`voice_${this.record.id}`);
      if(str) {
        const json = JSON.parse(str);
        this.record = {...this.record, ...json};
      }
      this.form.get('id').setValue(this.record.id);
      this.form.get('identity').setValue(this.record.identity);
      this.form.get('channelNum').setValue(this.record.channelNum);
      this.checkDisable = true;
      this.form.get('providerId').setValue(this.record.providerId);
      this.form.get('msgType').setValue(this.record.msgType);
      this.form.get('name').setValue(this.record.name);
      this.form.get('appId').setValue(this.record.appId);
      this.form.get('appKey').setValue(this.record.appKey);
      this.form.get('speed').setValue(this.record.speed);
      this.form.get('appSecret').setValue(this.record.appSecret);
      this.form.get('state').setValue(+this.record.state);
      this.form.get('templateId').setValue(this.record.templateId);
      this.form.get('carrierId').setValue(this.record.carrierId + '');
    } else {
      // this.http.get(url)
      this.http.post(urlSel, 3).subscribe(res => {
        this.optionList = res.data;
      });
    }
    this.form.get('hidControl').setValue(1);
    this.form.get('hidNameControl').setValue(1);
  }
  ngAfterViewInit() {
    if(this.record.id) {
      sessionStorage.removeItem(`voice_${this.record.id}`);
    }
  }
  save(value: any) {
    let url = URLS.addVoiceChannelManagement.url;
    if (this.record.id > 0) {
      url = URLS.editVoiceChannelManagement.url;
    }
    this.isSubmit = true;
    this.http.post(url, value).subscribe(res => {
      if (res.status === 0) {
        if (this.record.id > 0) {
          this.dialogService.notification.success(this.subject, '编辑成功');
        } else {
          this.dialogService.notification.success(this.subject, '新增成功');
        }
        // this.modal.close(true);
        this.close();
      } else {
        this.isSubmit = false;
        if (this.record.id > 0) {
          this.dialogService.notification.error(this.subject, '编辑失败' + res.errorMsg);
        } else {
          this.dialogService.notification.error(this.subject, '新增失败:' + res.errorMsg);
        }
      }
    });
  }

  close() {
    this.router.navigateByUrl('/information/channelManagement/voice');
  }
  ngNameChange() {
    // 防抖时间，单位毫秒
    debounceTime(1000);
    this.record.id = this.form.get('id').value;
    this.record.name = this.form.get('name').value;
    this.http.post(URLS.checkChannelName.url, {...this.record, msgType: this.messageService.getMsgTypeByName('voice')}).subscribe(res => {
      if (res.status === -1) {
        this.nameHid = false;
        this.form.get('hidNameControl').setValue(null);
      } else {
        this.nameHid = true;
        this.form.get('hidNameControl').setValue(1);
      }
    });
  }
  ngIdentityChange() {
    // 防抖时间，单位毫秒
    debounceTime(1000);
    this.record.id = this.form.get('id').value;
    this.record.identity = this.form.get('identity').value;
    this.http.post(URLS.checkChannelIdentity.url, this.record).subscribe(res => {
      if (res.status === -1) {
        this.identityHid = false;
        this.form.get('hidControl').setValue(null);
      } else {
        this.identityHid = true;
        this.form.get('hidControl').setValue(1);
      }
    });
  }
}
